"use client";

import { useLanguage } from "@/i18n/LanguageContext";

const stepsEn = [
  {
    num: "01",
    title: "Manufacturer submits product specs",
    desc: "Complete engineering drawings, material specifications, and assembly details are submitted to the Miami-Dade Product Control Section (PCA) for preliminary review.",
  },
  {
    num: "02",
    title: "Independent lab runs TAS testing",
    desc: "A certified third-party laboratory performs TAS 201 (large missile impact), TAS 202 (uniform static air pressure), and TAS 203 (cyclic wind loading) on production samples.",
  },
  {
    num: "03",
    title: "Engineering review by PCA",
    desc: "Miami-Dade engineers analyze test data, verify compliance with ASCE 7-22 design pressures, and confirm that the product meets HVHZ requirements for its intended WLZ classification.",
  },
  {
    num: "04",
    title: "NOA certificate issued",
    desc: "Upon approval, the Product Control Section issues a formal NOA certificate with a 5-year validity period. The NOA number must appear on every product label.",
  },
  {
    num: "05",
    title: "Annual re-listing required",
    desc: "Manufacturers must submit annual re-listing documentation confirming that production methods and material sources have not changed from the originally tested configuration.",
  },
];

const stepsEs = [
  {
    num: "01",
    title: "El fabricante presenta especificaciones del producto",
    desc: "Planos de ingeniería completos, especificaciones de materiales y detalles de ensamblaje se presentan a la Sección de Control de Productos (PCA) de Miami-Dade para revisión preliminar.",
  },
  {
    num: "02",
    title: "Laboratorio independiente realiza pruebas TAS",
    desc: "Un laboratorio certificado de terceros realiza TAS 201 (impacto de misil grande), TAS 202 (presión de aire estática uniforme) y TAS 203 (carga de viento cíclica) en muestras de producción.",
  },
  {
    num: "03",
    title: "Revisión de ingeniería por PCA",
    desc: "Los ingenieros de Miami-Dade analizan datos de prueba, verifican cumplimiento con presiones de diseño ASCE 7-22 y confirman que el producto cumple los requisitos HVHZ para su clasificación WLZ prevista.",
  },
  {
    num: "04",
    title: "Certificado NOA emitido",
    desc: "Tras la aprobación, la Sección de Control de Productos emite un certificado NOA formal con un período de validez de 5 años. El número NOA debe aparecer en cada etiqueta del producto.",
  },
  {
    num: "05",
    title: "Re-listado anual requerido",
    desc: "Los fabricantes deben presentar documentación anual de re-listado confirmando que los métodos de producción y fuentes de materiales no han cambiado desde la configuración originalmente probada.",
  },
];

export default function NoaWorkflow() {
  const { currentLang, t } = useLanguage();
  const steps = currentLang === "es" ? stepsEs : stepsEn;

  return (
    <section className="py-12">
      <h2 className="text-3xl font-bold text-[#064e3b] mb-8">
        {t("blog.codes.workflowHeading")}
      </h2>
      <div className="space-y-8">
        {steps.map((s) => (
          <div key={s.num} className="flex gap-6 items-start">
            <span className="flex-shrink-0 text-5xl font-black text-[#064e3b]/20 leading-none mt-1">
              {s.num}
            </span>
            <div>
              <h3 className="text-xl font-bold text-[#064e3b]">{s.title}</h3>
              <p className="text-sm text-gray-600 mt-2 leading-relaxed">{s.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}